<template>
   <form @submit.prevent>
      <CModal
         :title.sync="title"
         color="info"
         :closeOnBackdrop="false"
         size="lg"
         :show.sync="show"
      >
         <CRow>
            <CCol>
               <CRow>
                  <CCol>
                     <label>
                        {{
                           "Fullname: " + form.firstname + " " + form.lastname
                        }}
                     </label>
                  </CCol>
               </CRow>

               <CRow
                  ><CCol>
                     <label> {{ "Email: " + form.email }} </label>
                  </CCol>
               </CRow>
            </CCol>
         </CRow>

         <hr />
         <CRow>
            <CCol>
               <table>
                  <thead>
                     <tr>
                        <th v-for="item in fields" :key="item.title">
                           {{ item.title }}
                        </th>
                     </tr>
                  </thead>
                  <tbody>
                     <tr v-for="i in datas.data" :key="i.id">
                        <td>
                           {{ getClassName(i.batch_id) }}
                        </td>
                        <td>{{ getTemplateName(i.template_id) }}</td>
                        <td>{{ getSchedule(i.schedule_id) }}</td>
                        <td>
                           <CBadge v-if="i.attend == 0" color="danger"
                              >No</CBadge
                           >
                           <CBadge v-if="i.attend == 1" color="success"
                              >Yes</CBadge
                           >
                        </td>
                        <td>
                           <CBadge v-if="i.attend_date == null" color="danger"
                              >Not Yet</CBadge
                           >
                           <CBadge
                              v-if="i.attend_date != null"
                              color="success"
                              >{{ i.attend_date }}</CBadge
                           >
                        </td>
                     </tr>
                  </tbody>
               </table>
            </CCol>
         </CRow>

         <template #footer>
            <CButton @click="show = false" color="danger">Close</CButton>
         </template>
         <!-- <pre>{{ $data | json }}</pre> -->
      </CModal>
   </form>
</template>

<script>
import EventBus from "@/eventBus";
import classparticipant from "@/services/class_schedule";
import classbatch from "@/services/batch";
import classtemplate from "@/services/class_template";
import classschedule from "@/services/class_schedule";

export default {
   name: "peoplemodal",

   data() {
      return {
         show: false,
         title: "Default Title",
         mode: "",
         datas: [],
         batch_id: [],
         batch_name: [],
         template_id: [],
         template_name: [],
         schedule_id: [],
         schedule_date: [],
         form: {
            id: "",
            firstname: "",
            lastname: "",
            email: "",
         },
         fields: [
            { title: "Curriculum", sortable: false },
            { title: "Class", sortable: false },
            { title: "Class Date", sortable: false },
            { title: "Attend", sortable: false },
            { title: "Attend Date", sortable: false },
         ],
      };
   },
   computed: {},
   mounted() {},
   created() {
      var self = this;
      EventBus.$on("OPEN_SHOW_PARTICIPANT", (params) => {
         if (params.data) {
            classparticipant
               .getParticipantbyID(params.data)
               .then((res) => {
                  console.log(res, "ini participant");
                  this.datas = res;
                  self.show = true;
                  self.title = params.title;
                  self.mode = params.mode;
                  self.form.uuid = params.data;
                  self.form.firstname = res.people[0].firstname;
                  self.form.lastname = res.people[0].lastname;
                  self.form.email = res.people[0].email;
               })
               .catch((err) => {
                  var params = {
                     title: "Error",
                     mode: "danger",
                     data: err.response.data.message,
                  };
                  EventBus.$emit("OPEN_MODAL_ALERT", params);
               });
         } else {
            self.show = true;
            self.title = params.title;
            self.mode = params.mode;
            self.form.uuid = "";
            self.form.firstname = "";
            self.form.lastname = "";
            self.form.email = "";
         }
      });
      classbatch.getBatch().then((res) => {
         //this.classname = res.data
         for (let i = 0; i <= res.data.length - 1; i++) {
            this.batch_id.push(res.data[i].id);
            this.batch_name.push(res.data[i].name);
         }
      });
      classtemplate.getTemplate().then((res) => {
         //this.classname = res.data
         for (let i = 0; i <= res.data.length - 1; i++) {
            this.template_id.push(res.data[i].id);
            this.template_name.push(res.data[i].name);
         }
         classschedule.getSchedule().then((res) => {
            //this.classname = res.data
            console.log(res, "schedule");
            for (let i = 0; i <= res.data.length - 1; i++) {
               this.schedule_id.push(res.data[i].id);
               this.schedule_date.push(res.data[i].class_date);
            }
         });
      });
   },

   methods: {
      open() {
         this.show = true;
      },
      close() {
         this.show = false;
      },
      getClassName(temp) {
         return this.batch_name[this.batch_id.indexOf(temp)];
      },
      getTemplateName(temp) {
         return this.template_name[this.template_id.indexOf(temp)];
      },
      getSchedule(temp) {
         return this.schedule_date[this.schedule_id.indexOf(temp)];
      },
   },
};
</script>
